import React from "react";

export default function DetailCard({ title, info, file }) {
  return (
    <div className="col">
      <div className="row bg-primary p-3 rounded-top">
        <p className="m-0 text-white fw-bold">{title}</p>
      </div>
      <div
        className="row p-3 rounded-bottom gap-2"
        style={{ background: "white" }}
      >
        {info?.map((item) => {
          return (
            <div className="d-flex gap-2" style={{ fontSize: ".875rem" }}>
              <p className="m-0">{item.label}: </p>
              <p className="m-0 text-primary fw-medium">{item.value}</p>
            </div>
          );
        })}
        <div>
          {file?.attachment?.length > 0 && (
            <div className="mt-3">
              <p style={{ fontSize: ".875rem" }}>Attachment: </p>
              <ul className="list-unstyled">
                {file?.attachment?.map((fileURL, index) => {
                  const fullFileName = fileURL.split("/").pop();

                  // Split by "_" and get the last part
                  const fileName = fullFileName.split("_").pop();

                  return (
                    <li
                      key={index}
                      className="mb-2 d-flex align-items-center w-100"
                    >
                      <a
                        href={fileURL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-outline-primary d-flex align-items-center flex-grow-1 text-truncate"
                        style={{
                          textDecoration: "none",
                          padding: "8px",
                          borderRadius: "8px",
                          minWidth: "0", // Allow proper shrinking of buttons
                          marginRight: "0", // Remove right margin
                        }}
                      >
                        <i
                          className="bi bi-file-earmark-fill me-2"
                          style={{ color: "#D18237" }}
                        ></i>
                        <span className="text-truncate">
                          {fileName || `File ${index + 1}`}
                        </span>
                      </a>
                      {/* Delete button */}

                      {/* <i
                        className="bi bi-trash text-danger ms-3"
                        onClick={() => handleDeleteFile(index)}
                      ></i> */}
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
